export enum RewardType {
  VOUCHER = 0,
  LOTTERY_TICKET = 1,
}
